const Menu = [{
    title: "Dashboard",
    action: " mdi-memory",
    items: [{
        path: "dashboard/dashboard1",
        title: "Dashboard1",
        group: "dshboard1"
    },{
        path: "dashboard/dashboard2",
        title: "Dashboard2",
        group: "dshboard2"
    }


    ],
}, {
    title: "Exchange",
    action: "explore",
    items: [{
            path: "exchange/exchange-price",
            title: "Exchange Price",
            group: "crypto"
        }, {
            path: "exchange/exchange-transactions",
            title: "Exchange Transactions",
            group: "crypto"
        }, {
            path: "exchange/exchange-traders",
            title: "Exchange Traders",
            group: "crypto"
        },

    ],

}, {
    title: "Markets",
    action: "mdi-cart-outline",
    items: [
        {
            path: "markets/market-trade",
            title: "Market Trade",
            group: "market"
        },
        {
            path: "markets/market-crypto",
            title: "MArket Crypto",
            group: "market"
        },



    ]
},  {
    title: "Users",
    action: "group_add",
    items: [  {
        path: "users/api-chat",
        title: "API",
        group: "users"
    },{
            path: "users/profile",
            title: "Profile",
            group: "users"
        },
        {
            path: "users/wallet",
            title: "My Wallet",
            group: "users"
        },
        {
            path: "users/settings",
            title: "Settings",
            group: "users"
        },



    ]
}, 
{
    title: "Others",
    action: " mdi-web",
    items: [{
            path: "others/technical-analysis",
            title: "Technical Analysis",
            group: "others"
        },
        
        {
            path: "others/symbol-info",
            title: "Symbol Info",
            group: "others"
        }, 



        {
            path: "others/heat-map",
            title: "Heat Map",
            group: "others"
        },
        {
            path: "others/sign-in",
            title: "Sign In",
            group: "others"
        },
        {
            path: "others/sign-up",
            title: "Sign Up",
            group: "others"
        },
        {
            path: "others/error404",
            title: "Error 404",
            group: "others"
        }, {
            path: "",
            title: "Home",
            group: "others"
        }

    ]
},





]


export default Menu